import Vue from 'vue'
import Router from 'vue-router'

import ActivityFinishPage from "../views/gameLottery/activityFinished/activityFinishPage.vue"
import channelPromotion from "./modules/channelPromotion";
import gameLottery from "./modules/gameLottery";
import marathon from "./modules/marathon";
import protocol from "./modules/protocol";
import home from './modules/home';
Vue.use(Router)

export default new Router({
  routes: [
    {
      path:"/",
      redirect:"/home"
    },
    home,
    gameLottery,
    channelPromotion,
    marathon,
    protocol,
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    return {
      x: 0,
      y: 0,
    };
  },

})



// WEBPACK FOOTER //
// ./src/router/index.js